import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ConfigProvider, theme } from "antd";
import { Login } from "./pages/Login/Login";
import { Navbar } from "./common/Navbar/Navbar";
import { Table } from "./pages/table/Table";
import { UserProvider } from "./context/user-context";
import { Navbar_loggedin } from "./common/Navbar/Navbar-loggedin";
import { AdminLogin } from "./pages/AdminLogin/AdminLogin";

const router = createBrowserRouter([
	{
		path: "/",
		element: (
			<div className="app-shell">
				<Navbar />
				<Login />
			</div>
		)
	},
	{
		path: "/admin",
		element: (
			<div className="app-shell">
				<Navbar />
				<AdminLogin />
			</div>
		)
	},
	{
		path: "/table",
		element: (
			<div className="app-shell download_section">
				<Navbar_loggedin />
				<Table />
			</div>
		)
	}
]);

const antdTheme = {
	algorithm: theme.defaultAlgorithm,
	token: {
		colorPrimary: "#b5673b",
		colorBgBase: "#ffffff",
		colorText: "#2c2722",
		colorBorder: "#ece3d4",
		borderRadius: 12,
		fontFamily: "'IBM Plex Sans', system-ui, sans-serif"
	}
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<ConfigProvider theme={antdTheme}>
			<UserProvider>
				<RouterProvider router={router} />
			</UserProvider>
		</ConfigProvider>
	</React.StrictMode>
);
